import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const names = ['María', 'Sofía', 'Lucas', 'Mariana', 'Valentina', 'Matías', 'Camila', 'Nicolás', 'Florencia', 'Santiago', 'Martina', 'Juan', 'Carolina', 'Diego', 'Paula', 'Facundo', 'Agustina', 'Tomás'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Resistencia', 'Corrientes', 'Bahía Blanca'];
export function SocialProofPopup() {
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setShow(true);
      setTimeout(() => {
        setShow(false);
      }, 4000);
    };
    // Show first notification after 3 seconds
    const initialTimeout = setTimeout(showNotification, 3000);
    // Then show every 8-12 seconds
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 4000 + 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-131">
      {show && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-lg shadow-2xl p-4 max-w-sm border border-gray-200" data-id="element-132">
          <div className="flex items-start gap-3" data-id="element-133">
            <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-134" />
            <div data-id="element-135">
              <p className="text-sm font-semibold text-gray-900" data-id="element-136">
                {notification.name} de {notification.city}
              </p>
              <p className="text-xs text-gray-600 mt-0.5" data-id="element-137">
                acaba de comprar De Psicólogo a RRHH
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}